function getWidestWidth(selector, scope = document) {
	const elements = scope.querySelectorAll(selector);
	let maxWidth = 0;

	elements.forEach(el => {
	  const width = el.getBoundingClientRect().width;
	  if (width > maxWidth) {
		maxWidth = width;
	  }
	});

	return maxWidth;
  }

var announcementBarEl = document.querySelector('.announcement-bar');
var autoPlaySpeedSetting = parseInt(announcementBarEl.dataset.autoplaySpeed);
var prevEl = announcementBarEl ? announcementBarEl.querySelector('.swiper-button-prev') : null;
var nextEl = announcementBarEl ? announcementBarEl.querySelector('.swiper-button-next') : null;
var swiperEl = announcementBarEl ? announcementBarEl.querySelector('.swiper') : null;
var numberOfSlides = announcementBarEl.querySelectorAll('.swiper-slide').length;

if(swiperEl) {
	var widestElSize = getWidestWidth('.announcement-bar__text', announcementBarEl);
	var padding = 80;
	announcementBarEl.querySelector('.announcement-bar-inner').style.maxWidth = `${widestElSize + (padding * 2)}px`;

	var swiper = new Swiper(swiperEl, {
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		autoplay: {
			delay: autoPlaySpeedSetting ? autoPlaySpeedSetting * 1000 : 5000,
			disableOnInteraction: false, // keeps autoplay running even after user interacts (optional)
			pauseOnMouseEnter: false     // optional: keep playing on hover
		},
		allowTouchMove: false,         // disables swipe gestures
		keyboard: {
			enabled: false               // disables keyboard nav
		},
		navigation: {
			nextEl: numberOfSlides > 1 ? nextEl : null,
			prevEl: numberOfSlides > 1 ? prevEl : null,
		},
		// navigation: false,             // disables nav arrows if you're not using them
		pagination: {
			clickable: false             // optional: disables clicking pagination bullets if you have them
		}
	});

	if (numberOfSlides <= 1) {
		nextEl.style.display = 'none';
		prevEl.style.display = 'none';
	}
}
